export enum CrudMode {
  NEW = 'new',
  EDIT = 'edit',
  VIEW = 'view',
  LIST = 'list',
}

export enum VerificationType {
  EMAIL = 'email',
  PHONE = 'phone',
  OTP = 'otp',
}

export enum SsoApplication {
  ADMIN = 'admin',
  USER = 'user',
}

export enum TenantReportType {
  USERS = 'users',
  CHILDREN = 'children',
  PROFILE_FORMS = 'profile_forms',
}

export enum ProjectReportType {
  USERS = 'users',
  CHILDREN = 'children',
  COMBINED_USERS = 'combined_users',
  COMBINED_CHILDREN = 'combined_children',
  COMBINED_COURSE_SESSIONS = 'combined_course_sessions',
}

export enum CourseReportType {
  STEPS = 'steps',
}

export enum TranslationState {
  NONE = 'none',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  OUTDATED = 'outdated',
  COMPLETED = 'completed',
}

export enum ReportTemplateType {
  TENANT = 'tenant',
  COURSE = 'course',
  PROJECT = 'project',
}

export enum ReportLevel {
  PROJECT = 'Project',
  ORGANIZATION = 'Organization',
}

export enum EnrollmentType {
  CHILD = 'child',
}

export enum CourseSubmissionStatus {
  ACTIVE = 'active',
  OUTDATED = 'outdated',
  COMPLETED = 'completed',
  DISCARDED = 'discarded',
}

export enum PdfReportLogAction {
  CREATED = 'created',
  DELETED = 'deleted',
  RESTORED = 'restored',
}

export enum ResourceItemType {
  RICH_TEXT = 'rich_text',
  LINK = 'link',
  TITLE_LINK = 'title_link',
  REFERENCE = 'reference',
  REFERENCE_TEXT = 'reference_text',
  VIDEO = 'video',
}

export const isResourceItemNameRequired = (type: ResourceItemType): boolean =>
  type !== ResourceItemType.RICH_TEXT;
